import { render, staticRenderFns } from "./list.vue?vue&type=template&id=75b49998&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b49998",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75b49998')) {
      api.createRecord('75b49998', component.options)
    } else {
      api.reload('75b49998', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=75b49998&scoped=true", function () {
      api.rerender('75b49998', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/chat/events/list.vue"
export default component.exports